<template lang="pug">
    v-container.text-center(fluid)
        bar-chart(:chart-data="dataChart" :options="options")
</template>

<script>
    import BarChart from '@/plugins/charts/BarChart.js'

    export default {
        components: {
            BarChart
        },
        props:{
            chart:{
                type: Object,
                default: function(){
                   return {}
                }
            }
        },
        computed:{
            dataChart(){
                return{
                    datasets: [
                        {
                            label: 'Money Out',
                            minBarLength: 2,
                            backgroundColor:'rgba(220,40,60,0.89)',
                            borderColor:[`rgba(220,220,220, 1)`],
                            data: this.chart.moneyOut,
                        },
                        {
                            label: 'Money In',
                            backgroundColor:'rgb(71,159,130)',
                            borderColor:`rgb(255, 15, 238)`,
                            data: this.chart.moneyIn,
                        },
                    ]
                }
            },
        },
        data () {
            return {
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontColor: "white",
                            },
                            gridLines: {
                                display: true,
                                color:'rgba(255,255,255,0.3)'
                            },
                            stacked: true
                        }],
                        xAxes: [ {
                            distribution: 'linear',
                            gridLines: {
                                display: false,
                            },
                            ticks: {
                                fontColor: "white",
                            },
                            stacked: true,
                            type: 'time',
                            time: {
                                unit: 'day',
                                unitStepSize: 1,
                                displayFormats: {
                                    'millisecond': 'MMM DD',
                                    'second': 'MMM DD',
                                    'minute': 'MMM DD',
                                    'hour': 'MMM DD',
                                    'day': 'MMM DD',
                                    'week': 'MMM DD',
                                    'month': 'MMM DD',
                                    'quarter': 'MMM DD',
                                    'year': 'MMM DD',
                                }
                            },

                        }]
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontColor: "white"
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        },
        mounted () {
        },

        methods: {
            dateFormated(date){
                const dateFormat = new Date(date);
                return `${dateFormat.getDate()}-${dateFormat.getMonth() + 1}-${dateFormat.getFullYear()}`;
            },
        }
    }
</script>
